import React from 'react'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom'
import { useMediaQuery } from '@mote/helpers'
import { useGeoLocationQuery } from '@mote/api'
import {
  SurveyError,
  StepError,
  Wizard,
  WizardController,
  WizardControls
} from './components'
import { useOnboarding } from './context'
import { getSteps } from './steps'

export const Survey = () => {
  const history = useHistory()
  const { state, updateState, postSurvey, toggleLoading } = useOnboarding()
  const [surveyError, setSurveyError] = React.useState(null)
  const [steps, setSteps] = React.useState(() => getSteps())
  const breakpoint = useMediaQuery([640, 992, 1200])
  const isMobile = React.useMemo(() => breakpoint <= 640, [breakpoint])
  const {
    data: geoLocation,
    loading: isGeoLocationLoading,
    error: geoLocationError
  } = useGeoLocationQuery()

  React.useEffect(() => {
    if (
      isGeoLocationLoading ||
      geoLocationError ||
      !geoLocation ||
      state.countryCode
    )
      return

    updateState({ countryCode: geoLocation.countryCode })
  }, [geoLocation, isGeoLocationLoading, geoLocationError, state.countryCode])

  function handleStepsChange(role) {
    setSteps(() => getSteps(role))
  }

  async function handleOnFinish() {
    toggleLoading()
    setSurveyError(null)
    const response = await postSurvey()

    if (response.error) {
      setSurveyError(
        'Something went wrong while posting your survey form. Please try again.'
      )
      toggleLoading()
      return
    }

    toggleLoading()
    history.push('/onboarding/upsell')
  }

  return (
    <>
      {geoLocationError && (
        <SurveyError>
          Something funky happened and we couldn't load the survey. It could be
          a network problem on your end or a server problem on our end. Please
          try again!
        </SurveyError>
      )}
      {!geoLocationError && (
        <>
          {surveyError && <StyledError message={surveyError} />}
          <Wizard
            initialStep={0}
            totalSteps={steps.length === 1 ? 6 : steps.length}
            disableNext
          >
            {isMobile && <WizardController isMobile />}
            {steps.map((Step, index) => {
              const isFirstStep = index === 0
              return (
                <Step
                  key={index}
                  index={index}
                  updateSteps={isFirstStep ? handleStepsChange : null}
                />
              )
            })}
            {!isMobile && <WizardController onFinish={handleOnFinish} />}
            {isMobile && (
              <WizardControls.NextButton
                onFinish={handleOnFinish}
                style={{ marginTop: '24px', width: '100%' }}
              />
            )}
          </Wizard>
        </>
      )}
    </>
  )
}

const StyledError = styled(StepError)`
  margin-top: 40px;
  margin-bottom: -16px;

  @media (max-width: 639px) {
    margin-top: 16px;
    margin-bottom: 0;
  }
`
